export class PartTypes {
  constructor(value, description) {
    this.value = value
    this.description = description
  }
}
